import {
  GET_COLLECTIONS_LOADING,
  GET_COLLECTIONS_SUCCESS,
  GET_COLLECTIONS_FAIL,
} from '../actions/action_types';

// todo: 整理目前 journal、article、collection 進新資料夾架構

export const FETCH_ARTICLES = {
  LOADING: GET_COLLECTIONS_LOADING,
  SUCCESS: GET_COLLECTIONS_SUCCESS,
  FAIL: GET_COLLECTIONS_FAIL,
};

export const CREATE_COLLECTIONS_FOLDER = {
  LOADING: 'createCollectionsFolderLoading',
  SUCCESS: 'createCollectionsFolderSuccess',
  FAIL: 'createCollectionsFolderFail',
};

export const DELETE_COLLECTIONS = {
  LOADING: 'deleteCollectionsLoading',
  SUCCESS: 'deleteCollectionsSuccess',
  FAIL: 'deleteCollectionsFail',
};

export const MOVE_COLLECTIONS_TO_FOLDER = {
  LOADING: 'moveCollectionsToFolderLoading',
  SUCCESS: 'moveCollectionsToFolderSuccess',
  FAIL: 'moveCollectionsToFolderFail',
};

export const COPY_COLLECTIONS_TO_FOLDER = {
  LOADING: 'copyCollectionsToFolderLoading',
  SUCCESS: 'copyCollectionsToFolderSuccess',
  FAIL: 'copyCollectionsToFolderFail',
};

export const FETCH_COLLECTIONS_FOLDERS = {
  LOADING: 'fetchCollectionsFolderLoading',
  SUCCESS: 'fetchCollectionsFolderSuccess',
  FAIL: 'fetchCollectionsFolderFail',
};

export const UPDATE_ALIAS_NAME_COLLECTION = {
  LOADING: 'updateAliasNameOfCollectionLoading',
  SUCCESS: 'updateAliasNameOfCollectionSuccess',
  FAIL: 'updateAliasNameOfCollectionFail',
};

export const UPDATE_FOLDER_NAME_COLLECTION = {
  LOADING: 'updateFolderNameOfCollectionLoading',
  SUCCESS: 'updateFolderNameOfCollectionSuccess',
  FAIL: 'updateFolderNameOfCollectionFail',
};

export const UPDATE_FOLDER_PUBLIC_STATUS_COLLECTION = {
  INIT: 'updateFolderPublicStatusOfCollectionInit',
  LOADING: 'updateFolderPublicStatusOfCollectionLoading',
  SUCCESS: 'updateFolderPublicStatusOfCollectionSuccess',
  FAIL: 'updateFolderPublicStatusOfCollectionFail',
};
